import React, { Component } from 'react'
import { Col, Menu, notification, Row, Button, Drawer, Form, Card, Avatar, Icon, Tag } from 'antd'
import { getUrlPushWrapper } from '../../routes'
import Request, { API_URL, LAPI_URL } from '../../request'
import Settings from '../_utils/settings'
import { connect } from 'react-redux'
import _ from 'lodash'
import { FormUtils as GetAllFormFields } from 'sz-react-utils'

@Form.create()
class ShowAddNumber extends Component {
    state = {
        visible: true,
        countryCodes: []
    }

    onClose = () => {
        this.setState({
            visible: false
        })

        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    loadCountries = () => {
        let params = {
            results: 1000,
            count: 1000
        }
        Request.getCountries(params).then(resp => {
            resp.data = resp.data.reduce((temp, vv) => {
                temp.push({ id: vv.countryPhoneCode, display: vv.countryPhoneCode })
                return temp
            }, [])
            this.setState({ countryCodes: resp.data })
        })
    }

    componentDidMount() {
        this.loadCountries()
    }

    handleAddNumberSubmit = (e) => {
        let { form, inquiryId } = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            let response = await Request.updateInquiry({ valData, _id: inquiryId })
            if (response.success) {
                notification.success({
                    message: 'New Number Added'
                })
            } else {
                notification.error({
                    message: response.message
                })
            }
            this.onClose()
        })
    }

    render() {
        let { form: { getFieldDecorator, setFieldsValue } } = this.props
        let { visible, countryCodes } = this.state
        let inputTypes = {
            fields: [
                {
                    label: 'Country Code',
                    key: 'newCountryCode',
                    type: 'select',
                    options: countryCodes,
                    onChange: v => {
                        setFieldsValue({ newCountryCode: v })
                    }
                },
                {
                    label: 'Mobile Number',
                    key: 'newMobile',
                    type: 'text'
                }
            ]
        }
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Add New Number
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={800}
                visible={visible}>
                <Card>
                    <Form onSubmit={this.handleAddNumberSubmit} style={{ marginTop: 8 }}>
                        <div>
                            <GetAllFormFields
                                apiurl={LAPI_URL}
                                inputSchema={inputTypes}
                                getFieldDecorator={getFieldDecorator}
                            />
                        </div>
                        <Row style={{ marginTop: '20px' }}>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.props.loading}>
                                    Save
                                </Button>
                            </Col>
                            <Col span={8} />
                        </Row>
                    </Form>
                </Card>
            </Drawer>
        )
    }
}

class StudentInfo extends React.Component {

    state = {
        current: 'mail',
        deskColor: null,
        deskNameObj: Settings.deskNameObj,
        showAddNumberDrawer: false,
        inquiryId: ''
    }

    componentDidMount() {
    }

    handleClick = e => {
    }

    closeAddNumberDrawer = () => {
        this.setState({ showAddNumberDrawer: false, inquiryId: '' })
    }

    sendBack = async level => {
        let { rollBackLevel } = this.props
        if (level) {
            rollBackLevel = level
        }

        let x = await Request.changeDesk({
            _id: this.props.data._id,
            atLevel: rollBackLevel
        })

        if (x.error) {
        } else {
            if (!level) {
                this.props.done()

                notification.success({
                    message: `Success! Student Moved To ${rollBackLevel}`
                })

            } else {
                await Request.changeDesk({
                    _id: this.props.data._id,
                    atLevel: 'Dead Inquiry'
                })
                this.props.done()
                notification.success({
                    message: 'Student Inquiry Dead'
                })

            }
        }
    }

    render() {
        let { info, dispatch } = this.props
        let { deskNameObj, showAddNumberDrawer, inquiryId } = this.state

        return (

            <div>
                {
                    showAddNumberDrawer ?
                        <ShowAddNumber inquiryId={inquiryId} onClose={this.closeAddNumberDrawer} />
                        : null
                }
                {/* <Row>
                    <Col span={6}>
                        <b>Student Name:</b> {info.studentName}(
                        {info.id})
                    </Col>

                    <Col span={6}>
                        <b>Mobile:</b>
                        {(info.countryCode ? info.countryCode : '') + '' + info.mobile}{info.atLevel === "Claim Desk" ? <Button className='ant-btn-primary' onClick={(e) => { this.setState({ showAddNumberDrawer: true, inquiryId: info._id }) }} type='button' style={{ marginLeft: 10, height: 30, width: 30 }} >+</Button> : null}<br />
                        {info.newMobile ? <b>Mobile:</b> : null}
                        {info.newMobile ? (info.newCountryCode ? info.newCountryCode : '') + '' + info.newMobile : null}

                    </Col>
                    <Col span={6}>
                        <b>Branch:</b>
                        {info.studentBranchId &&
                            info.studentBranchId.branchName}
                    </Col>
                    <Col span={6}>
                        <b style={{ color: Settings.deskColor(info.atLevel) }}>Current Desk :

                            <button onClick={() => {

                                let level = deskNameObj[info.atLevel]
                                level = level.split(' ')
                                level = level[0].toString().toLowerCase()

                                dispatch(
                                    getUrlPushWrapper(`desk.${level}`)
                                )

                            }}> {deskNameObj[info.atLevel]}</button>
                        </b>

                    </Col>
                </Row> */}
                <div style={{
                    background: '#fff',
                    padding: '12px 20px',
                    borderRadius: '10px',
                    border: '1px solid #e8e8e8',
                    boxShadow: '0 2px 6px rgba(0,0,0,0.02)',
                    marginBottom: '15px'
                }}>
                    <Row type="flex" align="middle" gutter={16}>
                        {/* Student Profile */}
                        <Col span={6}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Avatar icon="user" style={{ backgroundColor: '#1890ff', marginRight: 10 }} size="small" />
                                <div>
                                    <div style={{ fontSize: '12px', color: '#8c8c8c' }}>Student Name (ID)</div>
                                    <div style={{ fontWeight: 700, color: '#262626' }}>
                                        {info.studentName} <span style={{ color: '#1890ff' }}>({info.id})</span>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        {/* Contact Info */}
                        <Col span={6}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Icon type="phone" style={{ color: '#52c41a', marginRight: 10, fontSize: '16px' }} />
                                <div>
                                    <div style={{ fontSize: '12px', color: '#8c8c8c' }}>Mobile</div>
                                    <div style={{ fontWeight: 600 }}>
                                        {(info.countryCode ? info.countryCode : '') + info.mobile}
                                        {info.atLevel === "Claim Desk" && (
                                            <Button
                                                type="primary"
                                                size="small"
                                                shape="circle"
                                                icon="plus"
                                                style={{ marginLeft: 8, height: 22, width: 22, fontSize: '10px' }}
                                                onClick={(e) => { this.setState({ showAddNumberDrawer: true, inquiryId: info._id }) }}
                                            />
                                        )}
                                    </div>
                                    {info.newMobile && (
                                        <div style={{ fontSize: '12px', color: '#1890ff' }}>
                                            Alt: {(info.newCountryCode ? info.newCountryCode : '') + info.newMobile}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </Col>

                        {/* Branch Location */}
                        <Col span={6}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Icon type="environment" style={{ color: '#ff4d4f', marginRight: 10, fontSize: '16px' }} />
                                <div>
                                    <div style={{ fontSize: '12px', color: '#8c8c8c' }}>Branch</div>
                                    <div style={{ fontWeight: 600 }}>
                                        {info.studentBranchId && info.studentBranchId.branchName ? info.studentBranchId.branchName : 'NA'}
                                    </div>
                                </div>
                            </div>
                        </Col>

                        {/* Desk Status - Clickable */}
                        <Col span={6} style={{ textAlign: 'right' }}>
                            <div style={{ display: 'inline-block', textAlign: 'left' }}>
                                <div style={{ fontSize: '12px', color: '#8c8c8c', textAlign: 'right' }}>Current Desk</div>
                                <Tag
                                    color={Settings.deskColor(info.atLevel)}
                                    style={{
                                        cursor: 'pointer',
                                        padding: '4px 12px',
                                        borderRadius: '15px',
                                        fontWeight: 700,
                                        margin: 0,
                                        fontSize: '13px',
                                        border: 'none',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                    }}
                                    onClick={() => {
                                        let level = deskNameObj[info.atLevel];
                                        level = level.split(' ');
                                        level = level[0].toString().toLowerCase();
                                        dispatch(getUrlPushWrapper(`desk.${level}`));
                                    }}
                                >
                                    <Icon type="swap" style={{ marginRight: 6 }} />
                                    {deskNameObj[info.atLevel]}
                                </Tag>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(mapDispatchToProps)
    (StudentInfo)
